import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const ArrowTopRight = withDefaultIconProps(
  {
    color: '#1F2635',
    height: 30,
    width: 30,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 30 30">
      <Path
        d="M8.47 22.61L21.31 9.77L21.31 18.54C21.31 18.96 21.65 19.3 22.07 19.3C22.28 19.3 22.47 19.21 22.61 19.08C22.75 18.94 22.84 18.75 22.84 18.54V7.93C22.84 7.92 22.84 7.9 22.83 7.89C22.83 7.89 22.83 7.89 22.83 7.88C22.83 7.87 22.83 7.86 22.83 7.85C22.83 7.85 22.83 7.85 22.83 7.85C22.83 7.84 22.83 7.83 22.83 7.82C22.83 7.82 22.83 7.81 22.83 7.81C22.82 7.8 22.82 7.79 22.82 7.78L22.82 7.78C22.8 7.66 22.74 7.54 22.66 7.45C22.66 7.44 22.66 7.44 22.66 7.44C22.65 7.43 22.65 7.42 22.64 7.42C22.63 7.41 22.62 7.4 22.61 7.39C22.6 7.38 22.59 7.37 22.58 7.36C22.58 7.36 22.57 7.35 22.56 7.34C22.56 7.34 22.56 7.34 22.56 7.34C22.46 7.26 22.34 7.2 22.22 7.18L22.22 7.18C22.21 7.18 22.2 7.18 22.19 7.17C22.19 7.17 22.19 7.17 22.18 7.17C22.17 7.17 22.16 7.17 22.15 7.17C22.15 7.17 22.15 7.17 22.15 7.17C22.14 7.17 22.13 7.17 22.12 7.17C22.11 7.17 22.11 7.17 22.11 7.17C22.1 7.17 22.08 7.17 22.07 7.17L11.46 7.17C11.04 7.17 10.7 7.51 10.7 7.93C10.7 8.35 11.04 8.69 11.46 8.69L20.23 8.69L7.39 21.53C7.09 21.83 7.09 22.31 7.39 22.61C7.69 22.91 8.17 22.91 8.47 22.61Z"
        fill={color}
      />
    </Svg>
  ),
);
